import React, { useEffect, useState } from 'react';
import { FaCheckCircle, FaTimesCircle } from "react-icons/fa";
import Nav from '../../components/Nav/Nav';
import Footer from '../../components/Footer/Footer';
import DashboardNav from '../../components/Nav/DashboardNav'
import { useNavigate } from 'react-router-dom'
import siteImage from './Assets/site.png'
import { jwtDecode } from 'jwt-decode'
import { LOCAL_STORAGE_TOKEN_KEY } from '../../utils/constants';

const SiteGuidelines = () => {

    const [user, setUser] = useState(null)
    const navigate = useNavigate()

    // Decode the data 
    function decodeData(data) {
        return atob(data); // Base64 encoding
    }
    useEffect(() => {
        const storeToken = window.localStorage.getItem(LOCAL_STORAGE_TOKEN_KEY);
        // Decode the JWT token
        const decodedToken = storeToken ? decodeData(storeToken) : null;
        const userInfo = decodedToken ? jwtDecode(decodedToken) : null;
        if (userInfo) {

            setUser(userInfo?.user)
        }

    }, [navigate])

    return (
        <div className='overflow-x-hidden  '>

            {user ? <DashboardNav /> : <Nav />}
            <div className="pt-[96px] md:pt-[117px] px-[24px]  md:px-[32px] xl:px-[64px] flex flex-col justify-center items-center ">
                <div className="flex flex-col items-center mb-4 ">
                    <img src={siteImage} alt="siteguidelines" className="size-[173px] lg:size-[237px]" />
                    <h1 className="text-[24px] leading-[100%] lg:text-xxl font-black">Site Guidelines</h1>
                </div>
                <div className=' px-[18px]  md:px-[25px]  lg:px-[29px]  xl:px-[37px] pt-[19px] md:pt-[27px] xl:pt-[36px] bg-ravbg rounded-[10px] pb-[76px]'>

                    <section className="mb-6 font-medium">
                        <h2 className="text-sm font-black">Rate A Vendor Site Guidelines</h2>
                        <p className="text-sm  text-ravash mt-3">
                            Welcome to Rate A Vendor! To maintain a fair, transparent, and respectful community, we have established these guidelines for posting reviews.
                        </p>
                    </section>

                    <section className="mb-6 font-medium">
                        <h2 className="text-sm font-black">Posting Reviews</h2>
                        <ul className="list-disc list-inside text-sm mt-2  text-ravash">
                            <li>Vendor ratings should only be submitted by clients who have personally hired or are working with the vendor.</li>
                            <li>Each client may post only one (1) review per vendor. Rate A Vendor is not a platform for reporting illegal or dangerous activities.</li>
                        </ul>
                    </section>

                    <section className="mb-6">
                        <h2 className="text-sm font-black">How We Moderate Reviews</h2>
                        <p className=" text-sm mt-2  text-ravash font-medium">
                            Our moderation team carefully reviews
                            all submitted ratings to ensure they align
                            with our guidelines. We aim to uphold a
                            fair and consistent moderation process
                            for all users, whether clients or vendors.
                            If you believe a review violates our
                            guidelines, please email us at
                            <span className='text-black font-black'> info@rateavendor.com. </span> We will assess
                            whether to remove it but will not edit
                            reviews to comply. We also do not
                            remove ratings solely for being low or
                            negative.
                        </p>
                    </section>

                    <section className="mb-6 text-sm font-medium">
                        <h2 className="font-black">Review Guidelines</h2>
                        <h3 className=" font-medium mt-1 mb-6">For Clients</h3>
                        <ul className="mt-2 space-y-2 text-ravash">
                            {[
                                "Be honest - Share your genuine experience.",
                                "Stay relevant - Focus on your event and vendor experience.",
                                "Speak for yourself - Avoid hearsay; encourage others to post their own reviews.",
                                "Keep it constructive - Explain why a vendor wasn’t right in a helpful way.",
                                "Remain professional - Angry or profane reviews may be removed.",
                                "Provide substance - Reviews without meaningful content may be removed.",
                                "One review per event - Spamming or multiple reviews for the same event may result in removal.",
                                "Use discretion - Consider all perspectives when reading reviews."
                            ].map((item, index) => {
                                const [firstWord, ...rest] = item.split(" - ");
                                return (
                                    <li key={index} className="flex text-sm items-start gap-2">
                                        <FaCheckCircle className="text-[#009DFF]  shrink-0" />
                                        <span>
                                            <span className='text-black font-black'>{firstWord}</span> — {rest.join(" — ")}
                                        </span>
                                    </li>
                                );
                            })}
                        </ul>

                    </section>

                    <section className="text-sm font-medium mb-6 ">
                        <h3 className=" mb-6">For Vendors</h3>
                        <ul className="mt-2 space-y-2 text-ravash">
                            {[
                                "Client reviews are for clients - Vendors cannot submit reviews for themselves.",
                                "Negative reviews will not be removed unless they violate guidelines - We do not take sides in disputes.",
                                "We cannot verify review details - Our role is not to determine facts in client-vendor disagreements.",
                                "If you suspect spam or abuse, contact us - Email info@rateavendor.com for assistance.",
                                "Encourage client reviews - More reviews mean a more accurate representation of your services."
                            ].map((item, index) => {
                                const [firstWord, ...rest] = item.split(" - ");
                                return(
                                <li key={index} className="flex  text-sm items-start gap-2">
                                    <FaCheckCircle className="text-[#009DFF]  shrink-0" />
                                    <span>
                                        <span className='text-black font-black'>{firstWord}</span> — {rest.join(" - ")}
                                    </span>
                                </li>
                                );
                            })}
                        </ul>
                    </section>

                    <section className="mb-6">
                        <h2 className="text-sm font-black">Reservation Rights</h2>
                        <p className="text-sm mt-2 text-ravash font-medium">Rate A Vendor reserves the right to remove content that:</p>
                        <ul className="mt-2 space-y-2 font-medium text-sm text-ravash">
                           
                                <li  className="flex items-start gap-2 ">
                                    <FaTimesCircle className="text-[#EB0728] mt-1 shrink-0" />
                                    <span>Contains <strong className='font-black text-black'>inappropriate, defamatory, obscene, or offensive </strong>  language.</span>
                                </li>

                                <li  className="flex items-start gap-2 ">
                                    <FaTimesCircle className="text-[#EB0728] mt-1 shrink-0" />
                                    <span>Promotes <strong className='font-black text-black'>hate, discrimination, threats, or harassment.  </strong></span>
                                </li>

                                <li  className="flex items-start gap-2 ">
                                    <FaTimesCircle className="text-[#EB0728] mt-1 shrink-0" />
                                    <span> <strong className='font-black text-black'>Impersonates others </strong>   or misrepresents experiences.</span>
                                </li>

                                <li  className="flex items-start gap-2 ">
                                    <FaTimesCircle className="text-[#EB0728] mt-1 shrink-0" />
                                    <span>Violates our  <strong className='font-black text-black'>Terms of Service or Privacy Policy. </strong></span>
                                </li>
                            
                            <li>We may also report threatening
                                comments to law enforcement when necessary.</li>

                            <li>By using Rate A Vendor, you agree to
                                these guidelines. Thank you for
                                helping us build a trustworthy
                                community!</li>
                        </ul>
                    </section>
                </div>


            </div>
            <Footer />
        </div>

    );
};

export default SiteGuidelines;